import { apiInstance } from "./networking";
export const coIsAdminCheckReason = async (payload) => {
    const {data = {}} = await apiInstance.post(`primary/is-admin-check`,payload);
    return data;
};